export const environment = {
    logLevel: 'warn',
    production: true,
    stage: false,
    appVersion: '1.0.1',

    // From the first production backend deploy (2026-09-01). Must stay in step with
    // the PROD_ORIGIN_URL / PROD_SOCKET_ENDPOINT repo Variables, which the backend
    // workflow reads to run migrations.
    origin: "https://7t0jsuen84.execute-api.ap-southeast-1.amazonaws.com/prod",
    socketOrigin: "wss://n4h9jvh9rf.execute-api.ap-southeast-1.amazonaws.com/prod",

    // Permanent custom domain. CloudFront (d2m9voayvuvw3p.cloudfront.net) still
    // serves it, but this is the address users see and share.
    appUrl: "https://clienteling-production.hthai-aws.gillcapitalinternal.com",

    // MCP is not deployed for this product (matches environment.stage.ts).
    mcpAgentUrl: "",
    mcpGatewayUrl: "",

    // hthai-prod-network:ResourcesBucketName
    bucketUrl: "https://hthai-prod-resources.s3.ap-southeast-1.amazonaws.com",
    cdnUrl: "https://hthai-prod-resources.s3.ap-southeast-1.amazonaws.com",

    tisImageUploaderMobileAppUrl: "https://d17x8xgdpn6izq.cloudfront.net",

    // Must match VAPID_PUBLIC_KEY in backend/serverless.prod.yml, and the private
    // half in the PROD_VAPID_PRIVATE_KEY secret. If these drift, push
    // subscriptions fail to validate.
    vapidKey: "BOndNBoOgVFSlaBZmTcnidd3xw3OrC-vziOSaEUNroW4bMuCLmK-bunPTeOU1-OdA2o9Ph1D6DZKzmQB2szHacQ",
};
